export default "__VITE_ASSET__C9g5clEZ__"